import MyBookings from '@/views/consultation-workspace/MyBookings.vue';
import ClientList from '@/views/consultation-workspace/ClientList.vue';
import ClientDetail from '@/views/consultation-workspace/ClientDetail.vue';
import ClientConsultationHistory from '@/views/consultation-workspace/ClientConsultationHistory.vue';
import VersionEditor from '@/views/finance-version/VersionEditor.vue';
import ConsultationConclusion from '@/views/consultation-workspace/ConsultationConclusion.vue';
import { TeamOutlined } from '@ant-design/icons-vue';

export const consultationWorkspaceRoutes = [
    {
        path: 'consultation-workspace',
        name: 'ConsultationWorkspace',
        meta: {
            title: '諮詢工作台',
            icon: TeamOutlined
        },
        children: [
            {
                path: '',
                redirect: { name: 'ConsultationWorkspaceBookings' }
            },
            {
                path: 'bookings',
                name: 'ConsultationWorkspaceBookings',
                component: MyBookings,
                meta: { title: '我的預約' }
            },
            {
                path: 'overview',
                redirect: { name: 'ConsultationWorkspaceBookings' },
                name: 'ConsultationWorkspaceDashboard',
                meta: { title: '工作台首頁', hideInMenu: true }
            },
            {
                path: 'clients',
                name: 'ConsultationWorkspaceClients',
                component: ClientList,
                meta: { title: '我的學員' }
            },
            {
                path: 'clients/:userId',
                name: 'ConsultationWorkspaceClientDetail',
                component: ClientDetail,
                meta: { title: '學員詳情', hideInMenu: true, hidePageChrome: true }
            },
            {
                path: 'clients/:userId/consultations',
                name: 'ConsultationWorkspaceClientConsultations',
                component: ClientConsultationHistory,
                meta: { title: '諮詢紀錄', hideInMenu: true, hidePageChrome: true }
            },
            {
                path: 'versions/create',
                name: 'ConsultationWorkspaceVersionCreate',
                component: VersionEditor,
                meta: { title: '新增諮詢版本', hideInMenu: true, hidePageChrome: true }
            },
            {
                path: 'versions/view/:id',
                name: 'ConsultationWorkspaceVersionView',
                component: VersionEditor,
                meta: { title: '檢視版本', hideInMenu: true, hidePageChrome: true }
            },
            {
                path: 'versions/edit/:id',
                name: 'ConsultationWorkspaceVersionEdit',
                component: VersionEditor,
                meta: { title: '編輯版本', hideInMenu: true, hidePageChrome: true }
            },
            {
                path: 'clients/:userId/conclusion/:version',
                name: 'ConsultationWorkspaceConclusion',
                component: ConsultationConclusion,
                meta: { title: '諮詢結論', hideInMenu: true, hidePageChrome: true }
            }
        ]
    }
];
